module.exports = __webpack_public_path__ + "static/media/styles.2382e342.less";